import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { Language, Logo } from "@/components/Brand";

export default function Auth({ mode, lang, t, change, onAuth }) {
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const fa = lang === "fa";

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then((r) => { onAuth(r.data); navigate("/workspace", { replace: true }); }).catch(() => {});
  }, [navigate, onAuth]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      const r = await api.post(`/auth/${mode === "login" ? "login" : "register"}`, form);
      onAuth(r.data); navigate("/workspace");
    } catch (err) { setError(errorText(err, "Please check your details and try again.")); } finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/workspace";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="auth-page">
      <div className="auth-aside">
        <Logo t={t} />
        <div>
          <p className="eyebrow">NOORIN / نورین</p>
          <h2>{fa ? "شفافیت، نقطه شروع تصمیم درست است." : "Clarity is where the right decision starts."}</h2>
          <p>{fa ? "یک فضای خصوصی برای شناخت بهتر کسب‌وکار شما." : "A private workspace for understanding your business more deeply."}</p>
        </div>
        <span className="aside-foot">See deeper. Decide better.</span>
      </div>
      <div className="auth-main">
        <div className="auth-top"><Language lang={lang} change={change} /><button className="text-button" onClick={() => navigate("/")} data-testid="auth-back-home">{fa ? "صفحه اصلی" : "Home"}</button></div>
        <form className="auth-form" onSubmit={submit} data-testid={`${mode}-form`}>
          <p className="eyebrow">{mode === "login" ? t.welcomeEyebrow : t.beginEyebrow}</p>
          <h1>{mode === "login" ? t.loginTitle : (fa ? "فضای کاری خود را بسازید." : "Create your private workspace.")}</h1>
          <p className="auth-sub">{t.loginSub}</p>
          {mode === "register" && <label>{fa ? "نام شما" : "Your name"}<input data-testid="register-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></label>}
          <label>{t.email}<input type="email" required data-testid={`${mode}-email-input`} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@business.com" /></label>
          <label>{t.password}<input type="password" required minLength="8" data-testid={`${mode}-password-input`} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" /></label>
          {mode === "login" && <button type="button" className="text-button" onClick={() => navigate("/forgot-password")} data-testid="forgot-password-link">{fa ? "رمز عبورت رو فراموش کردی؟" : "Forgot password?"}</button>}
        {error && <div className="form-error" data-testid="auth-error">{error}</div>}
          <button className="primary-button full" disabled={busy} data-testid={`${mode}-submit-button`}>{busy ? "…" : t.continue}<ArrowUpRight size={17} /></button>
          <div className="or"><span>{t.or}</span></div>
          <button type="button" className="google-button" onClick={google} data-testid="google-sign-in-button"><span>G</span>{t.google}</button>
          <p className="switch-auth">{mode === "login" ? t.noAccount : (fa ? "قبلاً حساب ساخته‌اید؟" : "Already have an account?")} <button type="button" onClick={() => navigate(mode === "login" ? "/register" : "/login")} data-testid="auth-mode-switch">{mode === "login" ? t.register : t.sign}</button></p>
        </form>
      </div>
    </div>
  );
}
